
import * as algolia from './algolia';

export {
    algolia
  };

 
  


// WEBPACK FOOTER //
// ./src/assets/algolia/index.js